const template = require('./searchBox.template');
require('./searchBox.styles');

/**
* @ngdoc directive
* @name sharebase.directive:sbSearchBox
* @module sharebase
* @restrict E
* @description
*
* `sbSearch` enables searching sharebase folders
*
* @usage
*
* <sb-search-box placeholder="Search My Files" search-type="content" full-results-url="#/search-results"/>
* 
* 
* @param {string=} placeholder The placeholder text to show in the input.  Default
* value is 'Search'
*
* @param {string=} searchType Controls type of items to be searched. Valid values are
* 'content' (default)
*
* @param {expression=} onFullResults Function expression to call when full search
* results are requested.
*
* @param {expression=} onSelection Function expression to call when an item is selected from 
* the autocomplete list.
*/
export function SearchBoxDirective(
	$timeout:ng.ITimeoutService
) {
	return {
		restrict: 'E',
		controller: SearchController,
		controllerAs: 'searchCtlr',
		bindToController: true,
		template,
		scope: {
			placeholder: '@',
			searchType: '@',
			onFullResults: '&',
			onSelection: '&'
		},
		link: function (scope, element, attrs) {
			if (!attrs.searchTarget || attrs.searchTarget === '') {
				scope.searchCtlr.searchType = 'content';
			}

			var searchInput;
			//wait for template to be compiled
			var t = setInterval(function () {
				if (element.find('input').length > 0) {
					clearInterval(t);
					element.find('input').bind('keypress', beginFullSearch);
					searchInput = element.find('input');
				}
			}, 100);

			function beginFullSearch(event) {
				var key = event.keyCode || event.charCode;
				if (key === 13) {
					if (searchInput[0].value.length === 0) {
						//do nothing if no search characters
						return;
					}
					element.find('input').blur();
					scope.$apply(function () {
						//kick off search
						var val = searchInput[0].value;

						scope.searchCtlr.loadFullResults(val);
					});

				}
			}

			scope.searchCtlr.clearSearchInput = function () {
				$timeout(function () {
					scope.searchCtlr.selectedItem = undefined;
					scope.searchCtlr.searchText = '';
					searchInput.blur();
				}, 800);
			};

			scope.$on('$destroy', function () {
				element.find('input').blur();
				element.find('input').unbind('keypress', beginFullSearch);

				//clean up 
				var body = document.querySelector('body');
				var searchScrollMask = document.querySelector('body .md-scroll-mask');
				if (searchScrollMask) {
					body.removeChild(searchScrollMask);
				}
			});
		}
	};
}

SearchBoxDirective.$inject = [
	'$timeout'
];

function SearchController(
	$q:ng.IQService, 
	$state, 
	sbSearchService, 
	localStorageService, 
	gettextCatalog:ng.gettext.gettextCatalog
) {
	var self = this;
	self.searchService = sbSearchService;
	self.searchResults = searchResults;
	self.loadFullResults = loadFullResults;
	self.selectedItemChange = selectedItemChange;
	self.addSearchHistory = addSearchHistory;

	if (!self.placeholder) {
		self.placeholder = gettextCatalog.getString('Search');
	}	

	function searchResults(val) {
		if (!val || val.length < 3) {
			//show recent search/items
			return getRecentItems();
		}

		//show search results
		var deferred = $q.defer();
		sbSearchService.getResults(val, 10).then(function (data) {
			if (data.hasMore) {
				//add a new item show full results
				data.results.push({ historyTerm: 'See more results for \'' + val + '\'', showMore: true });
			}
			deferred.resolve(data.results);
		});

		return deferred.promise;
	}

	function selectedItemChange(item) {
		if (!item) {
			return;
		}

		self.clearSearchInput();
		if (item.historyTerm) {
			if (item.showMore) {
				//load the rest of the results
				self.onSelection({ item: self.searchText });
				self.addSearchHistory(self.searchText);
			}
			else if (item.historyTerm) {
				self.onSelection({ item: item.historyTerm });
				self.addSearchHistory(item.historyTerm);
			}
		}
		else {
			//folder or file
			self.onSelection({ item: item });
			if (item.FolderId) {
				folderClicked(item);
			}
			if (item.DocumentId) {
				itemClicked(item);
			}
		}
		self.clearSearchInput();
	}

	function loadFullResults(term) {
		self.clearSearchInput();
		self.addSearchHistory(term);
		self.onSelection({ item: term });
	}

	function folderClicked(folder) {
		//add to recent searched items
		var contentAdd:any = {};
		contentAdd.FolderId = folder.FolderId;
		contentAdd.name = folder.name;
		contentAdd.Type = folder.Type;
		addItemSelectedHistory(contentAdd);
	}

	function itemClicked(item) {
		//add to recent searched items
		var contentAdd:any = {};
		contentAdd.DocumentId = item.DocumentId;
		contentAdd.name = item.name;
		contentAdd.Icon = item.Icon;
		addItemSelectedHistory(contentAdd);
	}

	var recentSearchList;
	function getRecentItems() {
		if (!recentSearchList) {
			//get search history
			recentSearchList = getSearchHistory();
			//used to add a border between search/item history
			if (recentSearchList.length > 0) {
				recentSearchList[recentSearchList.length - 1].isLast = true;
			}
			var selectedHistory = getItemSelectedHistory();
			angular.forEach(selectedHistory, function (item) {
				recentSearchList.push(item);
			});

			angular.forEach(recentSearchList, function (item) {
				var hdate = new Date(item.searchTime);
				var now = new Date();
				var yesterday = new Date();
				yesterday.setDate(yesterday.getDate() - 1);

				item.timeLabel = 'older';
				if (hdate.getDate() === now.getDate()) {
					item.timeLabel = hdate.toLocaleTimeString();
					var seconds = hdate.getSeconds() > 9 ? hdate.getSeconds() : '0' + hdate.getSeconds();
					item.timeLabel = item.timeLabel.replace(':' + seconds + ' ', ' ');
				}
				else if (hdate.getDate() === yesterday.getDate()) {
					item.timeLabel = 'yesterday';
				}
			});
		}
		return recentSearchList;
	}

	function addItemSelectedHistory(item) {
		recentSearchList = undefined; //clear current recents and force it to be rebuilt
		var selectedItems = localStorageService.getStoredValue('sharebase' + self.searchType + 'ItemHistory');
		var selectedItemsJSON;
		if (selectedItems === '') {
			selectedItemsJSON = [];
		}
		else {
			selectedItemsJSON = JSON.parse(selectedItems);
		}

		//remove previous similar selectedItems entries
		selectedItemsJSON = selectedItemsJSON.filter(function (iselectedItem) {
			return (item.name.toLowerCase() !== iselectedItem.name.toLowerCase());
		});

		//add new term to beginning
		item.searchTime = new Date();
		selectedItemsJSON.unshift(item);
		//save last x terms
		var last = JSON.stringify(selectedItemsJSON.slice(0, 4));
		localStorageService.setStoredValue('sharebase' + self.searchType + 'ItemHistory', last);
	}
	function addSearchHistory(term) {
		recentSearchList = undefined; //clear current recents and force it to be rebuilt
		var searches = localStorageService.getStoredValue('sharebase' + self.searchType + 'SearchHistory');
		var searchesJSON;
		if (searches === '') {
			searchesJSON = [];
		}
		else {
			searchesJSON = JSON.parse(searches);
		}

		//remove previous similar term entries
		searchesJSON = searchesJSON.filter(function (search) {
			return (search.historyTerm.toLowerCase() !== term.toLowerCase());
		});

		//add new term to beginning
		searchesJSON.unshift({ historyTerm: term, searchTime: new Date() });
		//save last x terms
		var last = JSON.stringify(searchesJSON.slice(0, 4));
		localStorageService.setStoredValue('sharebase' + self.searchType + 'SearchHistory', last);

	}

	function getItemSelectedHistory() {
		var items = localStorageService.getStoredValue('sharebase' + self.searchType + 'ItemHistory');
		if (items === '') {
			return [];
		}
		return JSON.parse(items);
	}
	function getSearchHistory() {
		var searches = localStorageService.getStoredValue('sharebase' + self.searchType + 'SearchHistory');
		if (searches === '') {
			return [];
		}
		return JSON.parse(searches);
	}
}

SearchController.$inject =  [
	'$q', 
	'$state', 
	'sbSearchService', 
	'localStorageService', 
	'gettextCatalog'
]; 


// WEBPACK FOOTER //
// ./src/sharebase/components/searchBox/searchBox.ts